import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import WorkInGolfHero from '@components/work-in-golf-hero/index'
import StatisticsCallout from '@components/statistics-callout'
import CareerTracksVariant from '@components/career-tracks-variant'
import FloatingBox from '@components/floating-box'
import MemberBenefits from '@components/member-benefits'
import PathToGolf from '@components/path-to-golf/index'
import TestimonialV2 from '@components/testimonialv2/index'
import VideoSpotlight from '@components/video-spotlight'
import MarketingFormEmbed from '@components/marketing-form-embed/index'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import useStyles from './workingolf.styles'

const WorkInGolf = (props) => {
  const {
    metaDataField,
    metaImage,
    metaDescription,
    newsletterSignup,
    listCardAccordionSection,
    pathToGolfSection,
    careerSpecialistSection,
    testimonialsSection,
    careerTracksSection,
  } = props
  const styles = useStyles()

  const router = useRouter()
  const targetItemID = router?.query?.scrollTo
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const headerOffset = isMobile ? 45 : 90

  useEffect(() => {
    if (targetItemID) {
      const scrollToElement = document.getElementById(targetItemID)
      const desiredPosition = scrollToElement.getBoundingClientRect().top
        + window.scrollY - headerOffset
      window.scrollTo({ top: desiredPosition, behavior: 'smooth' })
    }
  }, [isMobile, targetItemID])

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaDataField}
        description={metaDescription}
        canonical={`${defaults.baseUrl}workingolf`}
        openGraph={{
          title: metaDataField,
          description: metaDescription,
          type: 'website',
          url: `${defaults.baseUrl}workingolf`,
          images: [{ url: metaImage && metaImage.url }],
        }}
      />
      <WorkInGolfHero {...props} nextComponentID="#kickstart-career" />
      <VideoSpotlight flipped {...props} />
      <StatisticsCallout {...props} />
      <MemberBenefits {...listCardAccordionSection} />
      <PathToGolf {...pathToGolfSection} />
      <CareerTracksVariant {...careerTracksSection} />
      <FloatingBox {...careerSpecialistSection} />
      <TestimonialV2 testimonialsData={testimonialsSection} />
      <MarketingFormEmbed {...newsletterSignup} />
    </div>
  )
}

WorkInGolf.propTypes = {
  metaDataField: PropTypes.string,
  metaImage: PropTypes.object,
  metaDescription: PropTypes.string,
  listCardAccordionSection: PropTypes.object,
  pathToGolfSection: PropTypes.object,
  careerSpecialistSection: PropTypes.object,
  testimonialsSection: PropTypes.object,
  careerTracksSection: PropTypes.object,
  newsletterSignup: PropTypes.object,
}

export default WorkInGolf
